import * as _ from 'lodash';
import * as moment from 'moment';
import { useMemo } from 'react';
import { IRecipientActivityLog } from '@nkr/models/index';
import { AgGridReact } from 'ag-grid-react';
import { Label, OverlayTrigger, Tooltip } from 'react-bootstrap';
import {
    IHeaderParams, GridReadyEvent, ValueGetterParams, FirstDataRenderedEvent, ICellRendererParams, SortChangedEvent, GridSizeChangedEvent, ColDef
} from 'ag-grid-community';
import { GridWrapper } from './styles';
import { fileTextO } from 'react-icons-kit/fa/fileTextO';
import SortableHeaderComponent from '@nkr/views/admin/center/list/common/sortable-header';
import Icon from 'react-icons-kit';
import PopoverTemplate from '@nkr/components/popover-template';
import { Utility } from '@nkr/services/utility';

interface IProps {
    data: IRecipientActivityLog[],
    onGridReady: (grid: GridReadyEvent) => void
}

const ActivityLog = (props: IProps) => {
    const onGridReady = (e: GridReadyEvent) => {
        e.api.sizeColumnsToFit();
        props.onGridReady(e);
    };

    const onFirstDataRendered = (e: FirstDataRenderedEvent) => {
        e.api.sizeColumnsToFit();
    };

    const onSortChanged = (e: SortChangedEvent) => {
        e.api.refreshCells();
    };

    const onGridSizeChanged = (e: GridSizeChangedEvent) => {
        // var grid = document.getElementById('grid-wrapper');

        // if (grid == null)
        //     return;

        // var gridWidth = grid.offsetWidth;

        // var columnsToShow = [];
        // var columnsToHide = [];

        // var totalColsWidth = 0;

        // var allColumns = e.columnApi.getAllColumns();

        // for (var i = 0; i < allColumns.length; i++) {
        //     var column = allColumns[i];

        //     totalColsWidth += column.getMinWidth();

        //     if (totalColsWidth > gridWidth) {
        //         columnsToHide.push(column.getColId);
        //     } else {
        //         columnsToShow.push(column.getColId);
        //     }
        // }

        // e.columnApi.setColumnsVisible(columnsToShow, true);
        // e.columnApi.setColumnsVisible(columnsToHide, false);

        e.api.sizeColumnsToFit();
    }


    const renderTooltip = (text) => (
        <Tooltip id="tooltip">{text}</Tooltip>
    );



    const columns: ColDef[] = [
        {
            colId: 'Rank',
            field: 'rank',
            headerComponentFramework: (params: IHeaderParams) =>
                <SortableHeaderComponent {...params}>
                    Row #
                </SortableHeaderComponent>,
            headerName: 'Row #',
            width: 70,
            sortable: false,
            suppressSizeToFit: true,
            valueGetter: (params: ValueGetterParams) => params.node.rowIndex + 1
        },
        {
            colId: 'activity',
            field: 'activity',
            headerName: 'Activity',
            headerComponentFramework: (params: IHeaderParams) =>
                <SortableHeaderComponent {...params}>
                    Activity
                </SortableHeaderComponent>,
            width: 220,
        },
        {
            colId: 'activityDate',
            field: 'activityDate',
            headerName: 'Activity Date',
            headerComponentFramework: (params: IHeaderParams) =>
                <SortableHeaderComponent {...params}>
                    Activity Date
                </SortableHeaderComponent>,
            width: 150,
            comparator: Utility.dateComparator
        },
        {
            colId: 'deadlineDate',
            field: 'deadlineDate',
            headerName: 'Deadline Date',
            headerComponentFramework: (params: IHeaderParams) =>
                <SortableHeaderComponent {...params}>
                    Deadline Date
                </SortableHeaderComponent>,
            cellRendererFramework: (props: ICellRendererParams) => {
                if (props.value != null) {
                    return moment(props.value).format('MM/DD/YYYY hh:mm')
                }
                else return '';
            },
            width: 150
        },
        {
            colId: 'potentialDonorCenter',
            field: 'potentialDonorCenter',
            headerName: 'Potential Donor Center',
            headerComponentFramework: (params: IHeaderParams) =>
                <SortableHeaderComponent {...params}>
                    Donor Center
                </SortableHeaderComponent>,
            width: 150,
        },
        {
            colId: 'potentialDonor',
            field: 'potentialDonor',
            headerName: 'Donor Alias',
            headerComponentFramework: (params: IHeaderParams) =>
                <SortableHeaderComponent {...params}>
                    Donor Alias
                </SortableHeaderComponent>,
            width: 150,
        },
        {
            colId: 'potentialDonorAge',
            field: 'potentialDonorAge',
            headerName: 'Donor Age',
            width: 80,
            headerComponentFramework: (params: IHeaderParams) =>
                <SortableHeaderComponent {...params}>
                    Donor Age
                </SortableHeaderComponent>,
            cellRendererFramework: (params: ICellRendererParams) => <>{params.value ? params.value : '??'}</>
        },
        {
            colId: 'singleEpletMmDr',
            field: 'singleEpletMmDr',
            headerName: 'Eplet MM',
            width: 100,
            headerComponentFramework: (params: IHeaderParams) =>
                <SortableHeaderComponent {...params}>
                    Eplet MM
                </SortableHeaderComponent>,
            cellRendererFramework: (params: ICellRendererParams) => {
                let data = params.data as IRecipientActivityLog;
                let { singleEpletMmDr, singleEpletMmDq } = data;
                let style = 'default';
                let displayLabel = '- ? -';

                if (singleEpletMmDr != null && singleEpletMmDq != null) {
                    if (singleEpletMmDr == 0 && singleEpletMmDq == 0) {
                        style = 'success';
                        displayLabel = '0 MM';
                    } else if (singleEpletMmDr < 7 && singleEpletMmDq < 9) {
                        style = 'success';
                        displayLabel = 'Low';
                    } else if (singleEpletMmDq >= 15) {
                        style = 'danger';
                        displayLabel = 'High';
                    } else {
                        style = 'warning';
                        displayLabel = 'Med';
                    }
                }

                return <Label bsStyle={style} style={{ fontSize: '90%' }}>{displayLabel}</Label>;
            },
            valueGetter: (params: ValueGetterParams) => {
                let data = params.data as IRecipientActivityLog;
                let { singleEpletMmDr, singleEpletMmDq } = data;

                let value = 0;

                if (singleEpletMmDr != null && singleEpletMmDq != null) {
                    if (singleEpletMmDr == 0 && singleEpletMmDq == 0) {
                        value = 0;
                    } else if (singleEpletMmDr < 7 && singleEpletMmDq < 9) {
                        value = 1;
                    } else if (singleEpletMmDq >= 15) {
                        value = 3;
                    } else {
                        value = 2;
                    }
                }

                return value;
            }
        },
        {
            colId: 'outcome',
            field: 'outcome',
            headerName: 'Outcome',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Outcome
                </SortableHeaderComponent>,
            width: 200,
        },
        {
            colId: 'outcomeReason',
            field: 'outcomeReason',
            headerName: 'Outcome Reason',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Outcome Reason
                </SortableHeaderComponent>,
            cellRendererFramework: (params: ICellRendererParams) => {
                let data = params.data as IRecipientActivityLog;
                let comments = data.outcomeReason ?? '';
                let truncatedReason = comments.length > 30 ? comments.substring(0, 30) + '...' : comments;

                if (comments) {
                    return (
                        <OverlayTrigger
                            trigger='hover'
                            placement={'left'}
                            rootClose
                            overlay={renderTooltip(comments)}
                        >
                            <span style={{ cursor: 'pointer' }}>{truncatedReason}</span>
                        </OverlayTrigger>
                    );
                }
                return 'N/A';
            },
            width: 220
        }
    ];

    const columnDefs = useMemo(() => columns, []);
    const rowData = useMemo(() => props.data, [props.data]);

    return (
        <>
            <GridWrapper id='grid-wrapper' className='ag-theme-bootstrap' style={{ height: 'calc(100vh - 450px)', width: '99.99%' }}>
                <AgGridReact
                    defaultColDef={{
                        cellClass: 'list-cell',
                        headerClass: 'list-header',
                        sortable: true,
                        resizable: false
                    }}
                    columnDefs={columnDefs}
                    rowData={rowData}
                    enableCellTextSelection={true}
                    enableRangeSelection={true}
                    suppressContextMenu={true}
                    suppressCellSelection={true}
                    noRowsOverlayComponentFramework={() => <div>No activity data found...</div>}
                    domLayout={props.data.length == 0 ? 'autoHeight' : null}
                    onGridReady={onGridReady}
                    onGridSizeChanged={onGridSizeChanged}
                    onFirstDataRendered={onFirstDataRendered}
                    onSortChanged={onSortChanged}
                />
            </GridWrapper>
        </>
    );
}


export default ActivityLog;
